import calendarsService from '../../services/calendarsService'

class CalendarsController {
  fetchCalendar = calendarsService.fetchCalendar
  fetchCalendars = calendarsService.fetchCalendars
  createCalendar = calendarsService.createCalendar
  updateCalendar = calendarsService.updateCalendar
}

export default new CalendarsController()
 


// WEBPACK FOOTER //
// ../src/controllers/calendarsController/calendarsController.js